const metaData = {
  fields: ['id','log_id', 'work_request_id', 'description', 'question_id', 'paper_id', 'created_at', 'updated_at'],
}

export default metaData
